export default __webpack_public_path__ + "static/vino1-5bdeaa91fa5b3f5d42b1502440a707e2.jpg";